Service = App.loadClass 'core::Angular/Service'

class exports.FieldsService extends Service
    constructor: (@http, @rootScope, @zones, @q) ->
        @process_mode = 'zone-add'

    all: () ->
        return @http.post 'backend/grower/fields/define/load-fields'

    structureFieldsSavePostOptions: (data) ->
        # data needed when we post to fields controller
        return {
            farms_id: if data?.farm?.id? then data.farm.id else null
            id: if data?.id? then data.id else null
            geom: data.geom
            name: data.name
            tillable_acres: data.area
        }

    saveGeometry: (options, api_data_token, year) ->
        return @http.post 'backend/grower/fields/define/update-field-geometry',
            options: @structureFieldsSavePostOptions(options)
            api_data_token: api_data_token
            year: year


    setGeojson: (@geojson) =>
        undefined

    setLayerTitle: (@layer_title) =>
        undefined

    setProcessMode: (@process_mode) =>
        undefined

    setFieldData: (@field_data) =>
        undefined

    setFieldsId: (@fields_id) =>
        undefined

    setYear: (@year) =>
        undefined

    setLayersId: (@layers_id) =>
        undefined

    getGeojson: () =>
        return @geojson
    getFieldData: () ->
        return if @field_data? then @field_data else null
    getFieldsId: () ->
        return if @fields_id? then @fields_id else null
    getYear: () ->
        return if @year? then @year else null
    getLayersId: () =>
        return @layers_id
    getProcessMode: () =>
        return @process_mode

    cleanup: () =>
        @setFieldData(null)
        @setFieldsId(null)
        @setYear(null)
        @setLayersId(null)
        @setLayerTitle(null)
        @setGeojson(null)
        @process_mode = 'zone-add'

    loadFieldById: (id) =>
        return @http.post('backend/grower/fields/edit', { fields_id: id }).then (response) =>
            if response.data.status.type is 'success'
                return response.data.data

    hasFieldprintAccess: () =>
        return @http.post('backend/grower/fields/fieldprint-access-check')

    makeFeature: (geometry, properties = {}) =>
        return { type: 'Feature', properties: properties, geometry: geometry }

    formatDataForAllZones: () =>
        @loadFieldById(@fields_id).then (result) =>
            # load field data and get template
            template = @fill(result.field, @getFieldData())
            template.boundary = @getGeojson()
            return template

    load: (cb, fill_zones = false, zone_id = false) ->
        # load the field data
        @loadFieldById(@fields_id).then (result) =>
            # set zones and field
            zones = result.zones
            field = result.field
            # populate template with formatted data
            template = @fill(field, @getFieldData())

            # if we just need the boundary
            if not fill_zones
                @setFieldData(template)
                cb(template)

            # if we need a single zone
            if fill_zones is 'single'
                # populate template with formatted zone and call callback
                @fillZone(zone_id, template, cb)


    fill: (old, neww) ->
        to_copy = ['name', 'farms_id', 'id', 'boundary', 'has_fieldprint_access']

        for i in to_copy
            neww[i] = old[i]

        # if neww.boundary? and neww.boundary?.coordinates?
        neww.boundary = @makeFeature(JSON.parse(neww.boundary))
        neww.farm = { id: old.farms_id }

        return neww

    fillZones: (zones, template, cb) =>
        # define promises array
        promises = []
        # Define callback for async loading of all zones
        zoneLoadingCallback = (response) =>
            if response.data.status.type is 'success'
                # alias zone data
                zone = response.data.data
                # translate zone type to property name
                zone_property = @mapZoneType(zone.zone_type)
                # alias the pre-existing properties for each zone on the template
                zone.loaded_zones = zone.areas
                zone.zones = []
                zone.editing = true

                # enable steps for this zone
                @enableChildSteps(template, zone.zone_type)
                # set the data on the template object
                template.zones[zone_property] = zone

        for id in zones
            # load zone data
            promises.push @zones.load(id, zoneLoadingCallback)

        return @q.all(promises).then () =>
            # update field data
            @setFieldData template
            # hit final cb
            cb(template)

    fillZone: (zone_id, template, cb) =>
        @fillZones([zone_id], template, cb)


    enableChildSteps: (template, zone_type) =>
        for step in template.zone_steps
            if step.name is zone_type
                step.enabled = true
                return

    mapZoneType: (type) =>
        return 'productivity' if type.toLowerCase().indexOf('productivity') > -1
        return 'irrigation' if type is 'Irrigation'
        return 'previous-crop' if type is 'Previous Crop'